/* eslint-disable no-restricted-syntax */
import { CompanyAccountModelDto } from '@treasury/api/channel';
import { TmHttpClient } from '@treasury/core/http';
import { FiDate } from '../../../dates';
import { TransferActionType } from '../../../transfers/transfer-action.type.js';
import {
    mapTransferActivityParameters,
    mapUpdateTransferParamsToRequest,
} from '../../mappings/transfers/map-transfer-request-params.js';
import { OutputType } from '../../types/download/output-type.type.js';
import AchConfigurationServices from '../ach/ach-configuration-services.js';
import DownloadService from '../download/download-service.js';

// TODO: there's some type cleanup that needs to be done here. Should be able to replace the old 'requests' file with this service + mappings
export default class TransferPaymentsService {
    public static async fetchTransferActivity({ parameters }: { parameters: object }) {
        const body = mapTransferActivityParameters(parameters);
        const http = await TmHttpClient.getInstance();
        const data = await http.request<unknown[]>(`internalTransfers/FilterTransfers`, {
            method: 'POST',
            body,
        });

        return {
            data,
            totalCount: data.length,
        };
    }

    public static async getTransfers(body: object) {
        const http = await TmHttpClient.getInstance();
        const data = await http.request<unknown[]>(`internalTransfers/FilterTransfers`, {
            method: 'POST',
            body,
        });

        return {
            data,
            totalCount: data.length,
        };
    }

    public static async fetchTransferAccounts() {
        return (await TmHttpClient.getInstance()).request<CompanyAccountModelDto[]>(
            `companyaccounts/GetWithProductFeature?type=To&productfeaturetype=InternalTransfer`,
            {
                method: 'GET',
            }
        );
    }

    public static async fetchAchConfig() {
        const configuration = (await AchConfigurationServices.getConfiguration()) as {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            cutoffTimes: any[];
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            holidays: any[];
            isSameDayAchEnabled: boolean;
        };
        return {
            cutoffTimes: configuration.cutoffTimes,
            holidays: configuration.holidays,
            allowSameDayPayments: configuration.isSameDayAchEnabled,
        };
    }

    public static async updateTransferStatus(
        action: TransferActionType,
        parameters: { comments: string; internalTransferId: string }
    ) {
        const { securityActionType, endpoint, data } = mapUpdateTransferParamsToRequest(
            action,
            parameters
        );

        const method = action === 'resubmit' ? 'PUT' : 'POST';

        return (await TmHttpClient.getInstance()).request(`internalTransfers/${endpoint}`, {
            method,
            body: {
                ...data,
                securityMessage: {
                    actionType: `${securityActionType}Transfer_ByName`,
                    errorCode: null,
                    hasAlternate: false,
                    message: null,
                    methodUsed: null,
                    oneTimePassword: null,
                    status: null,
                },
            },
        });
    }

    public static async downloadTransfers(
        outputType: OutputType,
        page: string,
        filterModel: object
    ) {
        const fileSuffix = new FiDate(new Date()).toIsoDate();
        const mappedDownloadRequestFilters = mapTransferActivityParameters(filterModel);
        const downloadFormats = [outputType];
        return DownloadService.download(
            fileSuffix,
            outputType,
            page,
            { ...mappedDownloadRequestFilters, page },
            downloadFormats
        );
    }
}
